import { sendStartupMetrics } from 'api/services/metrics/startup.services';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useParams, matchPath } from 'react-router-dom';
import { getRegion } from 'utils/Region';
import { useAppStartupMetrics } from './hooks/useAppStartupMetrics';
import { useInteractivityMetrics } from './hooks/useInteractivityMetrics';

const StartupMetrics = () => {
  const location = useLocation();
  const { displayModal: isInProfilesView } = useSelector(
    state => state.profilesManager,
  );
  const startupMetrics = useAppStartupMetrics();

  const getStartupDestination = pathname => {
    const carouselMatch = matchPath('/:country/:node', pathname);
    if (isInProfilesView) return 'profiles';
    if (pathname.includes('vcard')) return 'vcard';
    if (carouselMatch?.params?.country && carouselMatch?.params?.node) {
      return 'home_carousel';
    }
    if (pathname.includes('landing')) return 'home_landing';
    return null;
  };

  useInteractivityMetrics(interactionMetrics => {
    if (sessionStorage.getItem('sendedStartupMetrics')) return;
    let startupDestination = getStartupDestination(location.pathname);
    const completeMetrics = {
      eventType: 'AppStartupMetrics',
      startupDestination,
      ...startupMetrics,
      ...interactionMetrics,
      appVersion: __VERSION__,
      sessionId: crypto.randomUUID(),
      language: 'javascript',
      platform: 'web',
      deviceType: 'web',
      deviceBrand: navigator.vendor,
      deviceOS: navigator.userAgent,
      region: getRegion(),
    };
    console.log('Metricas completas:', completeMetrics);
    if (!startupDestination) return;

    sendStartupMetrics(completeMetrics);
  });

  return null;
};

export default StartupMetrics;
